import {
    createMountsGlazingGasketConfig,
    createMountsMullionsHorizontalConfig,
    createMountsMullionsVerticalConfig,
    createMountsCGFChannelHorizontalConfig,
    createMountsCGFChannelVerticalConfig,
    createMountsCGFFrameHorizontalConfig,
    createMountsCGFFrameVerticalConfig,
} from "../../base";
import { MountsService } from "@/app/services/mounts.service";
import { IComponentConfig } from "@/app/@types/base-component";
import { LineDividerCalculationService } from "@/app/services/line-dividers.service";
import { CGF350Code } from "@/app/constants";
import { Partition } from "@/app/domain/entities/partition";

const createNoDoorMountsCGFFrameVerticalConfig = (
    partition: Partition,
): IComponentConfig => {
    const length = MountsService.getCGFFrameVertical(partition);

    return createMountsCGFFrameVerticalConfig().qty(0).area(length).build();
};

const createNoDoorMountsCGFFrameHorizontalConfig = (
    partition: Partition,
): IComponentConfig => {
    const length = MountsService.getCGFFrameHorizontal(partition);

    return createMountsCGFFrameHorizontalConfig().qty(0).area(length).build();
};

const createNoDoorMountsCGFChannelVerticalConfig = (
    partition: Partition,
): IComponentConfig => {
    const length = MountsService.getCGFChannelVertical(partition);

    return createMountsCGFChannelVerticalConfig().qty(0).area(length).build();
};

const createNoDoorMountsCGFChannelHorizontalConfig = (
    partition: Partition,
): IComponentConfig => {
    const length = MountsService.getCGFChannelHorizontal(partition);

    return createMountsCGFChannelHorizontalConfig().qty(0).area(length).build();
};

const createSlidingDoorMountsMullionsHorizontalConfig = (
    partition: Partition,
): IComponentConfig => {
    const width = MountsService.getTotalWidth(partition);
    const height = MountsService.getTotalHeight(partition);

    // Переделали формулу, в задаче 8698v2rfj: было вот так width * horizontalLinesQty * sides

    const horizontalLinesQty =
        LineDividerCalculationService.calculateHorizontalDividers(
            CGF350Code,
            height,
        );

    const qty = Math.round(width * horizontalLinesQty) || 0;

    return createMountsMullionsHorizontalConfig()
        .qty(horizontalLinesQty)
        .width(width)
        .area(qty)
        .build();
};

const createSlidingDoorMountsMullionsVerticalConfig = (
    partition: Partition,
): IComponentConfig => {
    const width = MountsService.getTotalWidth(partition);
    const height = MountsService.getTotalHeight(partition);

    // Было 2 стороны, но потом почему-то изменилось на 1 (8698v2rfj)
    const sides = 1;

    const verticalLinesQty =
        LineDividerCalculationService.calculateVerticalDividers(
            CGF350Code,
            width,
        );

    const qty = Math.round(height * verticalLinesQty * sides) || 0;

    return createMountsMullionsVerticalConfig()
        .qty(verticalLinesQty)
        .width(height)
        .area(qty)
        .build();
};

const createSlidingDoorMountsGlazingGasketConfig = (
    partition: Partition,
): IComponentConfig => {
    const channelHorizontalLength =
        MountsService.getCGFChannelHorizontal(partition);
    const channelVerticalLength =
        MountsService.getCGFChannelVertical(partition);

    const channelLength = channelHorizontalLength + channelVerticalLength;
    const sides = 2;

    const qty = Math.round(channelLength * sides) || 0;

    return createMountsGlazingGasketConfig().qty(0).area(qty).build();
};

export const CGF400NoDoorsConfigs = (partition: Partition) => [
    createNoDoorMountsCGFFrameVerticalConfig(partition),
    createNoDoorMountsCGFFrameHorizontalConfig(partition),
    createNoDoorMountsCGFChannelVerticalConfig(partition),
    createNoDoorMountsCGFChannelHorizontalConfig(partition),
    createSlidingDoorMountsMullionsHorizontalConfig(partition),
    createSlidingDoorMountsMullionsVerticalConfig(partition),
    createSlidingDoorMountsGlazingGasketConfig(partition),
];
